import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import Apiurl from "../../Helpers/apiUrl";
import { handleApiError } from "../../Helpers/handleApiError ";
import Swal from "sweetalert2";

const getToken = () => localStorage.getItem("u_token");

export const fetchProductOptions = createAsyncThunk(
  "product/fetchopt",
  async (_, { rejectWithValue }) => {
    const token = getToken();
    if (!token)
      return rejectWithValue({
        message: "No token found, authorization failed.",
      });

    try {
      const response = await axios.get(
        `${Apiurl}admin/product/option`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      return response.data;
    } catch (error) {
      handleApiError(error, "Please try again later.");
      return rejectWithValue(
        error.response?.data || { message: "Failed to fetch." }
      );
    }
  }
);
export const fetchAdminClient = createAsyncThunk(
  "admin/clientopt",
  async (_, { rejectWithValue }) => {
    const token = getToken();
    if (!token)
      return rejectWithValue({
        message: "No token found, authorization failed.",
      });

    try {
      const response = await axios.get(
        `${Apiurl}admin/userlist/client-option`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      return response.data;
    } catch (error) {
      handleApiError(error, "Please try again later.");
      return rejectWithValue(
        error.response?.data || { message: "Failed to fetch." }
      );
    }
  }
);
export const fetchAdminSku = createAsyncThunk(
  "admin/skuopt",
  async (_, { rejectWithValue }) => {
    const token = getToken();
    if (!token)
      return rejectWithValue({
        message: "No token found, authorization failed.",
      });

    try {
      const response = await axios.get(
        `${Apiurl}admin/product/sku`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      return response.data;
    } catch (error) {
      handleApiError(error, "Please try again later.");
      return rejectWithValue(
        error.response?.data || { message: "Failed to fetch." }
      );
    }
  }
);

const initialState = {
  skuOpt: [],
  clientOpt: [],
  segmentOpt: [],
  collectionOpt: [],
  categoryOpt: [],
  roleOpt: [
    { value: 2, label: "IC" },
    { value: 3, label: "BSP" },
    { value: 4, label: "DSP" },
    { value: 5, label: "BD" },
    { value: 6, label: "Sales Enabler" },
    { value: 7, label: "Dealer" },
    { value: 8, label: "Studio" }
  ],
  monthOpt: [
    { value: 1, label: "Jan" },
    { value: 2, label: "Feb" },
    { value: 3, label: "Mar" },
    { value: 4, label: "Apr" },
    { value: 5, label: "May" },
    { value: 6, label: "Jun" },
    { value: 7, label: "Jul" },
    { value: 8, label: "Aug" },
    { value: 9, label: "Sep" },
    { value: 10, label: "Oct" },
    { value: 11, label: "Nov" },
    { value: 12, label: "Dec" }
  ],
  yearOpt: Array.from(
    { length: new Date().getFullYear() - 2023 + 1 },
    (_, i) => ({
      value: 2023 + i,
      label: String(2023 + i)
    })
  ),
  regionOpt: [
    { value: "WEST", label: "WEST" },
    { value: "SOUTH2", label: "SOUTH2" },
    { value: "SOUTH1", label: "SOUTH1" },
    { value: "NORTH", label: "NORTH" },
    { value: "EAST", label: "EAST" },
    { value: "CENTRAL", label: "CENTRAL" }
  ],
  stateOpt: [
    { value: "GOA", label: "GOA" },
    { value: "GUJARAT", label: "GUJARAT" },
    { value: "MUMBAI", label: "MUMBAI" },
    { value: "ROM", label: "ROM" },
    { value: "ANDHRA PRADESH", label: "ANDHRA PRADESH" },
    { value: "CHENNAI", label: "CHENNAI" },
    { value: "ROTN", label: "ROTN" },
    { value: "TELANGANA", label: "TELANGANA" },
    { value: "BANGLORE", label: "BANGLORE" },
    { value: "KERALA", label: "KERALA" },
    { value: "ROK", label: "ROK" },
    { value: "DELHI AND NCR", label: "DELHI AND NCR" },
    { value: "HARYANA", label: "HARYANA" },
    { value: "JAMMU AND KASHMIR", label: "JAMMU AND KASHMIR" },
    { value: "PUNJAB AND CHANDIGARH", label: "PUNJAB AND CHANDIGARH" },
    { value: "RAJASTHAN", label: "RAJASTHAN" },
    { value: "BIHAR", label: "BIHAR" },
    { value: "JHARKHAND", label: "JHARKHAND" },
    { value: "NORTH EAST", label: "NORTH EAST" },
    { value: "ODISHA", label: "ODISHA" },
    { value: "ASSAM", label: "ASSAM" },
    { value: "WEST BENGAL", label: "WEST BENGAL" },
    { value: "CHHATTISGARH", label: "CHHATTISGARH" },
    { value: "EASTERN UP", label: "EASTERN UP" },
    { value: "MADHYA PRADESH", label: "MADHYA PRADESH" },
    { value: "UTTARAKHAND", label: "UTTARAKHAND" },
    { value: "WESTERN UP", label: "WESTERN UP" }
  ],
  status: "idle",
  error: null,
};

const adminOptionSlice = createSlice({
  name: "log",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchProductOptions.pending, (state) => {
        state.error = null;
        state.status = "pending";
      })
      .addCase(fetchProductOptions.fulfilled, (state, action) => {
        state.categoryOpt = action.payload.data?.category?.map((i) => ({
          value: i,
          label: i
        })) || [];
        state.segmentOpt = action.payload.data?.priceSegment?.map((i) => ({
          value: i,
          label: i
        })) || [];
        state.collectionOpt = action.payload.data?.collection?.map((i) => ({
          value: i,
          label: i
        })) || [];
        state.status = "succeeded";
      })
      .addCase(fetchProductOptions.rejected, (state, action) => {
        state.error = action.payload;
        state.status = "failed";
      })
      .addCase(fetchAdminClient.pending, (state) => {
        state.error = null;
        state.status = "pending";
      })
      .addCase(fetchAdminClient.fulfilled, (state, action) => {
        state.clientOpt = action.payload.data?.map((i) => ({
          value: i.id,
          label: i.client_name
        })) || [];;
        state.status = "succeeded";
      })
      .addCase(fetchAdminClient.rejected, (state, action) => {
        state.error = action.payload;
        state.status = "failed";
      })
      .addCase(fetchAdminSku.pending, (state) => {
        state.error = null;
        state.status = "pending";
      })
      .addCase(fetchAdminSku.fulfilled, (state, action) => {
        state.skuOpt = action.payload.data?.map((i) => ({
          value: i.sku_code,
          label: i.sku_code
        })) || [];;
        state.status = "succeeded";
      })
      .addCase(fetchAdminSku.rejected, (state, action) => {
        state.error = action.payload;
        state.status = "failed";
      })
  },
});

export default adminOptionSlice.reducer;
